import { BaseEventProps } from "@tvg/amplitude";

export enum ModuleEventProps {
  PLACE_TYPE = "Place Type",
  ITEM_SELECTED = "Item Selected",
  SELECTION_SOURCE = "Selection Source",
  SELECTION_RACE_TYPE = "Selection Race Type"
}

export type EventProps = BaseEventProps & ModuleEventProps;

export enum MediatorEventType {
  NEXT_RACE = "PPM_NEXT_RACE",
  PREV_RACE = "PPM_PREVIOUS_RACE",
  PROMOS = "PPM_PROMOS",
  UPCOMING = "PPM_OPEN_UPCOMING",
  BACK = "PPM_GO_BACK",
  WAGER_SCROLL = "PPM_WAGER_SCROLL",
  WAGER_TYPE_SELECT = "PPM_WAGER_TYPE_SELECT",
  TIP_MORE = "PPM_RACING_TIP_MORE",
  CHANGE_RACE = "RACE_RESULTS_CHANGE_RACE",
  TRACK_SELECTOR = "TRACK_RACE_SELECTOR",
  RUNNER_SELECTION = "PPM_RUNNER_SELECTION_2",
  TOOLTIP_CLICK = "PPM_TOOLTIP_CLICKED",
  DEPOSIT_CLICK = "PPM_DEPOSIT_NOW_CLICK",
  REPEAT_BET_CLICK = "PPM_REPEAT_BET_CLICK",
  ON_REPEAT_BET_SUCCESSFULLY = "PPM_ON_REPEAT_BET_SUCCESSFULLY"
}

export interface EventData {
  type: MediatorEventType;
  payload: {
    trackName: string;
    raceNumber: number;
    optedIn: boolean;
    destinationUrl: string;
    label: string;
    mtp: number;
    actionName: string;
    module: string;
    expandAction: string;
    runnerId: string;
    action: string;
    betType: string;
    race: {
      track: {
        trackName: string;
      };
      type: {
        code: string;
      };
    };
    tag: string;
  };
}

export interface TrackSelectorData {
  type: MediatorEventType.TRACK_SELECTOR;
  payload: {
    currentRaceNumber: number;
    raceNumberSelected: number;
  };
}
export interface RepeatBetPayloadData {
  type: MediatorEventType.REPEAT_BET_CLICK;
  payload: {
    betAmount: number;
    betType: string;
    module: string;
    selectionSource: string;
    raceType: string;
  };
}
